function inputValid(identifier: string) {
  let element = document.getElementById(identifier)

  element?.classList.remove('is-invalid')
  element?.classList.add('is-valid')
}

function inputInvalid(identifier: string) {
  let element = document.getElementById(identifier)

  element?.classList.remove('is-valid')
  element?.classList.add('is-invalid')
}

function inputRestart(identifier: string) {
  let element = document.getElementById(identifier)

  element?.classList.remove('is-valid')
  element?.classList.remove('is-invalid')
}

function legendValid(container: string) {
  let element = document.getElementById(container)

  element?.classList.remove('d-block')
  element?.classList.add('d-none')
}

function legendInvalid(container: string) {
  let element = document.getElementById(container)

  element?.classList.remove('d-none')
  element?.classList.add('d-block')
}

function legendValidInvalidRestart(container: string) {
  let element = document.getElementById(container)

  element?.classList.remove('d-block')
  element?.classList.add('d-none')
}

function legendIconValid(identifier: string, container: string) {
  inputValid(identifier)
  legendValid(container)
}

function legendIconInvalid(identifier: string, container: string) {
  inputInvalid(identifier)
  legendInvalid(container)
}

function legendIconValidInvalidRestart(identifier: string, container: string) {
  inputRestart(identifier)
  legendValidInvalidRestart(container)
}

function legendValidRequired(container_1: string, container_2: string) {
  legendValid(container_1)
  legendValid(container_2)
}

function legendValidRequiredRestart(container_1: string, container_2: string) {
  legendValidInvalidRestart(container_1)
  legendValidInvalidRestart(container_2)
}

function legendIconValidRequired(identifier: string, container_1: string, container_2: string) {
  inputValid(identifier)
  legendValidRequired(container_1,container_2)
}

function legendIconValidRequiredRestart(identifier: string, container_1: string, container_2: string) {
  inputRestart(identifier)
  legendValidRequiredRestart(container_1, container_2)
}

function legendInvalidRequired(attribute: String, container_1: string, container_2: string) {
  if (attribute.length > 0) {
    legendInvalid(container_1)
    legendValid(container_2)
  } else {
    legendValid(container_1)
    legendInvalid(container_2)
  }
}

function legendIconInvalidRequired(attribute: string, identifier: string, container_1: string, container_2: string) {
  inputInvalid(identifier)
  legendInvalidRequired(attribute, container_1, container_2)
}

function legendIconValidRequiredConfirmation(identifier: string, container_1: string, container_2: string, container_3: string) {
  inputValid(identifier)
  legendValid(container_1)
  legendValid(container_2)
  legendValid(container_3)
}

function legendIconInvalidRequiredConfirmation(identifier: string, container_1: string, container_2: string, container_3: string) {
  inputInvalid(identifier)
  legendValid(container_1)
  legendValid(container_2)
  legendValid(container_3)
}

function legendIconValidInvalidRequiredConfirmation(expression: RegExp, attribute: string, value_confirmation: string, identifier: string, container_1: string, container_2: string, container_3: string) {
  inputInvalid(identifier)

  if (value_confirmation.length > 0) {
    legendValid(container_3)

    if (expression.test(value_confirmation)) {
      if (value_confirmation !== attribute) {
        legendInvalid(container_1)
        legendValid(container_2)
      }
    } else {
      legendValid(container_1)
      legendInvalid(container_2)
    }
  } else {
      legendValid(container_1)
      legendValid(container_2)
      legendValid(container_3)
  }
}

export { inputValid, inputInvalid, inputRestart, legendValid, legendInvalid, legendValidInvalidRestart, legendIconValid, legendIconInvalid, legendIconValidInvalidRestart, legendValidRequired, legendValidRequiredRestart, legendInvalidRequired, legendIconInvalidRequired, legendIconValidRequired, legendIconValidRequiredRestart, legendIconValidRequiredConfirmation, legendIconInvalidRequiredConfirmation, legendIconValidInvalidRequiredConfirmation }
